<template>
  <div style="padding: 10px">
    <!-- PC端搜索区域 -->
    <div class="search-pc" style="margin: 10px 0">
      <el-button type="primary" @click="load">查询</el-button>
      <el-button @click="resetData">重置</el-button>
      <el-button type="success" @click="sendLegacy">一键送券</el-button>
      <el-button type="warning" @click="batchSettlement">一键结算</el-button>
    </div>
    
    <!-- 移动端操作区 -->
    <div class="search-mobile">
      <div class="action-btns">
        <el-button type="primary" size="small" @click="load">查询</el-button>
        <el-button size="small" @click="resetData">重置</el-button>
        <el-button type="success" size="small" @click="sendLegacy">一键送券</el-button>
        <el-button type="warning" size="small" @click="batchSettlement">一键结算</el-button>
      </div>
    </div>

    <!-- PC端表格区域 -->
    <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%" class="table-pc">
      <el-table-column prop="accountName" label="角色名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="roleId" label="角色ID" show-overflow-tooltip></el-table-column>
      <el-table-column prop="legacyCount" label="送券数量" show-overflow-tooltip></el-table-column>
      <el-table-column prop="coin" label="咸鱼币数量" show-overflow-tooltip></el-table-column>
      <el-table-column prop="syncTime" label="同步时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" label="状态" show-overflow-tooltip>
        <template #default="scope">
          <el-tag :type="getStatusTagType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="primary" @click="handleSettlement(scope.row)">结算</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 移动端卡片 -->
    <div class="table-mobile" v-loading="loading">
      <div class="card-item" v-for="item in tableData" :key="item.id">
        <div class="card-row">
          <span class="card-label">角色名：</span>
          <span class="card-value">{{ item.accountName }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">送券数量：</span>
          <span class="card-value">{{ item.legacyCount }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">咸鱼币：</span>
          <span class="card-value">{{ item.coin }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">状态：</span>
          <el-tag size="small" :type="getStatusTagType(item.status)">{{ getStatusText(item.status) }}</el-tag>
        </div>
        <div class="card-row">
          <span class="card-label">同步时间：</span>
          <span class="card-value">{{ item.syncTime }}</span>
        </div>
        <div class="card-actions" v-if="userId === 1">
          <el-button size="small" @click="handleEdit(item)">编辑</el-button>
          <el-button size="small" type="primary" @click="handleSettlement(item)">结算</el-button>
        </div>
      </div>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-wrapper">
      <el-pagination class="pagination-pc" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      <el-pagination class="pagination-mobile" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>

    <!-- 编辑表单 -->
    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="50%">
      <el-form :model="form" ref="formRef" :rules="rules" label-width="120px">
        <el-form-item label="残券数量" prop="legacyCount">
          <el-input-number v-model="form.legacyCount" :min="0" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="咸鱼币数量" prop="coin">
          <el-input-number v-model="form.coin" :min="0" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 结算弹窗 -->
    <el-dialog title="残券结算" v-model="settlementDialogVisible" width="500px">
      <el-form :model="settlementForm" ref="settlementFormRef" :rules="settlementRules" label-width="100px">
        <el-form-item label="残券价格" prop="price">
          <el-input-number v-model="settlementForm.price" :min="0" :precision="2" style="width: 100%"
              placeholder="请输入每张残券的价格（元/万）" @change="calculatePayableAmount"></el-input-number>
        </el-form-item>
        <el-form-item label="残券数量">
          <el-input v-model="settlementForm.legacyCount" readonly style="width: 100%">
            <template #append>张</template>
          </el-input>
        </el-form-item>
        <el-form-item label="应付金额">
          <el-input v-model="settlementForm.payableAmount" readonly style="width: 100%">
            <template #append>元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="settlementDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveSettlement">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 一键结算弹窗 -->
    <el-dialog title="一键结算" v-model="batchSettlementDialogVisible" width="500px">
      <el-form :model="batchSettlementForm" ref="batchSettlementFormRef" :rules="batchSettlementRules" label-width="100px">
        <el-form-item label="残券价格" prop="price">
          <el-input-number v-model="batchSettlementForm.price" :min="0" :precision="2" style="width: 100%"
              placeholder="请输入每张残券的价格（元/万）"></el-input-number>
        </el-form-item>
        <el-form-item label="待结算角色">
          <el-tag v-for="roleId in batchSettlementRoleIds" :key="roleId" style="margin-right: 5px; margin-bottom: 5px;">
            {{ roleId }}
          </el-tag>
        </el-form-item>
        <el-form-item label="结算进度" v-if="batchSettlementProgress.total > 0">
          <el-progress :percentage="batchSettlementProgress.percentage" :status="batchSettlementProgress.status"></el-progress>
          <div style="margin-top: 5px; font-size: 12px; color: #909399;">
            {{ batchSettlementProgress.current }} / {{ batchSettlementProgress.total }}
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="batchSettlementDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="executeBatchSettlement" :loading="batchSettlementLoading">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'LegacySoldManagement',
  data() {
    return {
      dialogVisible: false,
      settlementDialogVisible: false,
      batchSettlementDialogVisible: false,
      batchSettlementLoading: false,
      batchSettlementForm: { price: 0 },
      batchSettlementRoleIds: ['265046744', '72344037', '66536621', '72349012', '73658164', '517720177', '86090854', '468094023', '72348666', '66537331', '66530770', '609790939'],
      batchSettlementProgress: { current: 0, total: 0, percentage: 0, status: '' },
      dialogTitle: '编辑',
      form: { id: '', legacyCount: 0, coin: 0, status: 0 },
      settlementForm: { id: '', price: 0, legacyCount: 0, payableAmount: 0, accountName: '', roleId: '' },
      formRef: null,
      settlementFormRef: null,
      userId: '',
      loading: true,
      search: {},
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      rules: {
        legacyCount: [{required: true, message: '请输入残券数量', trigger: 'blur'}],
        status: [{required: true, message: '请选择状态', trigger: 'change'}]
      },
      settlementRules: {
        price: [{required: true, message: '请输入残券价格', trigger: 'blur'}, {type: 'number', min: 0, message: '价格不能为负数', trigger: 'blur'}]
      },
      batchSettlementRules: {
        price: [{required: true, message: '请输入残券价格', trigger: 'blur'}, {type: 'number', min: 0, message: '价格不能为负数', trigger: 'blur'}]
      },
      statusOptions: [
        {label: '正常', value: 0},
        {label: '停用', value: 1},
        {label: '删除', value: 2}
      ]
    }
  },
  created() {
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
    this.load();
  },
  methods: {
    resetData() {
      this.search = {};
      this.currentPage = 1;
      this.load();
    },
    formatNumber(num) {
      return parseFloat(num.toFixed(2));
    },
    getCurrentTime() {
      const now = new Date();
      return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
    },
    sendLegacy() {
      this.loading = true;
      request.get("/xyzwws/websocket/legacySync").then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.$message({ type: "success", message: res.msg || "同步请求发送成功" });
          this.load();
        } else {
          this.$message({ type: "error", message: res.msg || "同步请求发送失败" });
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error("网络错误，同步请求失败");
      });
    },
    batchSettlement() {
      this.batchSettlementForm = { price: 0 };
      this.batchSettlementProgress = { current: 0, total: 0, percentage: 0, status: '' };
      this.batchSettlementDialogVisible = true;
    },
    async executeBatchSettlement() {
      this.$refs.batchSettlementFormRef.validate(async (valid) => {
        if (valid) {
          this.batchSettlementLoading = true;
          this.batchSettlementProgress = { current: 0, total: 0, percentage: 0, status: '' };

          try {
            // 先获取所有数据
            const res = await request.get("/legacySold/listPage", { params: { current: 1, size: 1000 } });
            if (res.code !== '0') {
              this.$message.error(res.msg || '获取数据失败');
              this.batchSettlementLoading = false;
              return;
            }

            const allData = res.data?.records || res.data?.list || res.data || [];
            // 筛选出指定角色且送券数量不为0的记录
            const toSettle = allData.filter(item =>
              this.batchSettlementRoleIds.includes(String(item.roleId)) &&
              parseInt(item.legacyCount || 0) > 0
            );

            if (toSettle.length === 0) {
              this.$message.warning('没有需要结算的记录');
              this.batchSettlementLoading = false;
              return;
            }

            this.batchSettlementProgress.total = toSettle.length;
            let successCount = 0;
            let failCount = 0;

            // 循环结算
            for (let i = 0; i < toSettle.length; i++) {
              const item = toSettle[i];
              const price = parseFloat(this.batchSettlementForm.price || 0);
              const legacyCount = parseInt(item.legacyCount || 0);
              const payableAmount = (price > 0 && legacyCount > 0) ? this.formatNumber(legacyCount * price / 10000.0) : 0;

              const transactionData = {
                accountName: item.accountName,
                roleId: item.roleId,
                roleParentId: item.roleParentId,
                price: payableAmount,
                type: 2,
                event: `卖券${legacyCount}，单价${price}元/万`,
                createTime: this.getCurrentTime()
              };
              const settlementData = { id: item.id, legacyCount: 0 };

              try {
                const orderRes = await request.post("/legacySoldOrder/save", transactionData);
                if (orderRes.code === '0') {
                  const updateRes = await request.post("/legacySold/update", settlementData);
                  if (updateRes.code === '0') {
                    successCount++;
                  } else {
                    failCount++;
                    console.error(`角色 ${item.roleId} 更新失败:`, updateRes.msg);
                  }
                } else {
                  failCount++;
                  console.error(`角色 ${item.roleId} 创建订单失败:`, orderRes.msg);
                }
              } catch (error) {
                failCount++;
                console.error(`角色 ${item.roleId} 结算异常:`, error);
              }

              // 更新进度
              this.batchSettlementProgress.current = i + 1;
              this.batchSettlementProgress.percentage = Math.round((i + 1) / toSettle.length * 100);
            }

            this.batchSettlementProgress.status = 'success';
            this.batchSettlementLoading = false;
            this.$message.success(`结算完成！成功 ${successCount} 条，失败 ${failCount} 条`);
            this.batchSettlementDialogVisible = false;
            this.load();
          } catch (error) {
            this.batchSettlementLoading = false;
            this.$message.error('一键结算失败: ' + (error.message || '未知错误'));
          }
        }
      });
    },
    handleEdit(row) {
      this.dialogTitle = '编辑';
      this.form = { id: row.id, legacyCount: row.legacyCount || 0, coin: row.coin || 0, status: row.status || 0 };
      this.dialogVisible = true;
    },
    handleSettlement(row) {
      this.settlementForm = {
        id: row.id, price: 0, legacyCount: parseInt(row.legacyCount || 0), payableAmount: 0,
        accountName: row.accountName || '', roleId: row.roleId || '', roleParentId: row.roleParentId || ''
      };
      this.settlementDialogVisible = true;
    },
    calculatePayableAmount() {
      const price = parseFloat(this.settlementForm.price || 0);
      const legacyCount = parseInt(this.settlementForm.legacyCount || 0);
      this.settlementForm.payableAmount = (price > 0 && legacyCount > 0) ? this.formatNumber(legacyCount * price / 10000.0) : 0;
    },
    saveSettlement() {
      this.$refs.settlementFormRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          const transactionData = {
            accountName: this.settlementForm.accountName, roleId: this.settlementForm.roleId,
            roleParentId: this.settlementForm.roleParentId,
            price: this.formatNumber(this.settlementForm.payableAmount), type: 2,
            event: `卖券${this.settlementForm.legacyCount}，单价${this.settlementForm.price}元/万`,
            createTime: this.getCurrentTime()
          };
          const settlementData = { id: this.settlementForm.id, legacyCount: 0 };
          request.post("/legacySoldOrder/save", transactionData).then(res => {
            if (res.code === '0') return request.post("/legacySold/update", settlementData);
            else throw new Error(res.msg || '创建交易记录失败');
          }).then(res => {
            this.loading = false;
            if (res.code === '0') {
              this.$message({ type: "success", message: "结算成功，已创建交易记录" });
              this.settlementDialogVisible = false;
              this.load();
            } else {
              this.$message({ type: "error", message: res.msg || "结算失败" });
            }
          }).catch(error => {
            this.loading = false;
            this.$message.error(error.message || "网络错误，结算失败");
          });
        }
      });
    },
    save() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          request.post("/legacySold/update", JSON.parse(JSON.stringify(this.form))).then(res => {
            this.loading = false;
            if (res.code === '0') {
              this.$message({ type: "success", message: res.msg || "编辑成功" });
              this.dialogVisible = false;
              this.load();
            } else {
              this.$message({ type: "error", message: res.msg || "编辑失败" });
            }
          }).catch(error => {
            this.loading = false;
            this.$message.error("网络错误，编辑失败");
          });
        }
      });
    },
    load() {
      this.loading = true;
      const params = { current: this.currentPage, size: this.pageSize };
      Object.keys(this.search).forEach(key => {
        if (this.search[key] !== '' && this.search[key] !== undefined && this.search[key] !== null) {
          params[key] = this.search[key];
        }
      });
      request.get("/legacySold/listPage", { params: params }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          let data = res.data;
          if (Array.isArray(data)) { this.tableData = data; this.total = data.length; }
          else if (data && data.records) { this.tableData = data.records || []; this.total = data.total || 0; }
          else if (data && data.list) { this.tableData = data.list || []; this.total = data.total || 0; }
          else { this.tableData = []; this.total = 0; }
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = []; this.total = 0;
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error('网络错误，加载失败');
        this.tableData = []; this.total = 0;
      });
    },
    getStatusTagType(status) {
      switch (parseInt(status)) { case 0: return 'success'; case 1: return 'warning'; case 2: return 'danger'; default: return 'info'; }
    },
    getStatusText(status) {
      const option = this.statusOptions.find(item => item.value === parseInt(status));
      return option ? option.label : '未知';
    },
    handleSizeChange(pageSize) { this.pageSize = pageSize; this.currentPage = 1; this.load(); },
    handleCurrentChange(pageNum) { this.currentPage = pageNum; this.load(); }
  }
}
</script>

<style scoped>
/* PC端/移动端显示控制 */
.search-mobile, .table-mobile, .pagination-mobile { display: none; }

.search-mobile .action-btns {
  display: flex;
  gap: 10px;
}

/* 移动端卡片样式 */
.card-item {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 10px;
}

.card-row {
  display: flex;
  align-items: center;
  padding: 5px 0;
  font-size: 14px;
}

.card-label {
  color: #909399;
  width: 80px;
  flex-shrink: 0;
}

.card-value {
  color: #303133;
  flex: 1;
}

.card-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .search-pc, .table-pc, .pagination-pc { display: none !important; }
  .search-mobile, .table-mobile, .pagination-mobile { display: block !important; }
  
  /* 暗色模式 */
  .card-item {
    background: #2a2a2a;
    border: 1px solid #3a3a3a;
  }
  
  .card-label { color: #909399; }
  .card-value { color: #e6a23c; }
  .card-actions { border-top-color: #3a3a3a; }
}
</style>
